import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e128502c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-hover settings f-row f-center-center" }
const _hoisted_2 = { class: "settings__popup__wrapper" }
const _hoisted_3 = { class: "on-hover__popup settings__popup" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "on-hover settings f-row f-center-center" }
const _hoisted_6 = { class: "settings__popup__wrapper" }
const _hoisted_7 = { class: "on-hover__popup settings__popup" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "on-hover settings f-row f-center-center" }
const _hoisted_10 = { class: "settings__popup__wrapper settings__popup__wrapper--flags" }
const _hoisted_11 = { class: "f-1 on-hover__popup settings__popup settings__popup--flags" }
const _hoisted_12 = ["src", "alt", "onClick"]

import { languages, changeLanguage } from "@/helpers/i18n";

import {
    soundProps,
    changeMusicVolume,
    changeSoundVolume,
} from "@/helpers/sound";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsIcons',
  props: {
    isBottom: Boolean,
},
  setup(__props) {



function handleChangeMusicVolume(event) {
    changeMusicVolume(event.target.value);
}
function handleChangeSoundVolume(event) {
    changeSoundVolume(event.target.value);
}

return (_ctx: any,_cache: any) => {
  const _component_SimpleButton = _resolveComponent("SimpleButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'f-row-1': true,
            'settings-is-bottom': __props.isBottom,
        })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SimpleButton, {
        isSmall: "",
        icon: "music",
        isIcon: ""
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "range",
            min: "0",
            step: "0.01",
            max: "1",
            value: _unref(soundProps).musicVolume,
            class: "settings-slider",
            id: "myRange",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (handleChangeMusicVolume($event)))
          }, null, 40, _hoisted_4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_SimpleButton, {
        isSmall: "",
        icon: "volume-high",
        isIcon: ""
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("input", {
            type: "range",
            min: "0",
            step: "0.01",
            max: "1",
            value: _unref(soundProps).soundVolume,
            class: "settings-slider",
            id: "myRange",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (handleChangeSoundVolume($event)))
          }, null, 40, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_SimpleButton, {
        isSmall: "",
        icon: "earth-europe",
        isIcon: ""
      }),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
            return (_openBlock(), _createElementBlock("img", {
              key: language,
              class: "settings-flag",
              src: `/assets/flags/${language}.svg`,
              alt: language,
              onClick: ($event: any) => (_unref(changeLanguage)(language))
            }, null, 8, _hoisted_12))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})